import { linkTo } from "querypieces";
import { gql } from "apollo-boost";

export default gql`
query {
  globalSet (handle: "programMap") {
    ...on programMap_GlobalSet {
      programMap {
        ...on programMapBlock_Entry {
          searchLabel
          searchPlaceholder
          filterLabel
          ctaText
          ${linkTo}
          locales {
            ...on programMapLocalesCountry_Entry {
              id
              countryName
              regions
              ${linkTo}
            }
          }
          clubWithNoContactMessage
          noLocationsInView {
            ...on cta_Entry {
              id
              message
              ${linkTo}
              linkStyle
            }
          }
          countryLinks {
            ...on country_Entry {
              id
              ${linkTo}
            }
          }
        }
      }
    }
  }
}
`;
